import React from "react";

import { Measuringpoint } from "@nens/brostar/openapi-client";
import { ColumnDefinition } from "@nens/chakra/components";

import { TableOverview } from "@/components/table-overview";
import { renderDefault } from "@/helpers/table-render-functions";
import { useAllFetchedPagination } from "@/hooks/use-pagination";
import { DeleteGmnMeausuringPointButton, addDeleteButton } from "@/libs/delete-button";
import { useGmnMeasuringPointListAllPagesQuery } from "@/queries/query-gmn-measuring-point";

export const gmnMeasuringPointInformation: { key: keyof Measuringpoint; label: string }[] = [
  { key: "eventType", label: "Gebeurtenis naam" },
  { key: "gmwBroId", label: "Put ID" },
  { key: "tubeNumber", label: "Buisnummer" },
  { key: "tubeStartDate", label: "Startdatum" },
  { key: "tubeEndDate", label: "Einddatum" },
];

const columnDefinitions: ColumnDefinition<Measuringpoint>[] = addDeleteButton(
  gmnMeasuringPointInformation.map(({ key, label }, index) => ({
    title: label,
    renderFunction: (row) =>
      renderDefault(row[key], index === 0 ? `/gmn/meetpunt/${row.uuid}/` : undefined),
    width: "1fr",
  })),
  DeleteGmnMeausuringPointButton
);

const GmnMeasuringPointTable: React.FC<{ gmn: string }> = ({ gmn }) => {
  const { data, isLoading } = useGmnMeasuringPointListAllPagesQuery({ gmn });

  let gmnMeasuringPointList = data?.results;
  if (gmnMeasuringPointList != null) {
    // FUTURE add endpoint to gmn to filter by anything but GMN_StartRegistration,
    // otherwise we have to fetch all and filter client side
    gmnMeasuringPointList = gmnMeasuringPointList.filter(
      (measuringPoint) => measuringPoint.eventType !== "GMN_StartRegistration"
    );
    gmnMeasuringPointList.sort((a, b) => {
      // If both dates are undefined, they are equal
      if (a.tubeStartDate == null && b.tubeStartDate == null) return 0;

      // If a.date is undefined, b should come first
      if (a.tubeStartDate == null) return 1;

      // If b.date is undefined, a should come first
      if (b.tubeStartDate == null) return -1;

      // Otherwise, compare the dates
      return a.tubeStartDate.getTime() - b.tubeStartDate.getTime();
    });
  }

  const { paginatedTableData, ...paginationProps } = useAllFetchedPagination(
    false,
    gmnMeasuringPointList ?? []
  );

  // if evenType is GMN_StartRegistration, remove it of the list, otherwise sort by tubeStartDate

  return (
    <TableOverview
      themeColor="#b9acfc"
      isLoading={isLoading}
      tableData={paginatedTableData}
      columnDefinitions={columnDefinitions}
      paginationProps={paginationProps}
    />
  );
};

export { GmnMeasuringPointTable };
